const countryOptions = [
  { code: "+34", name: "España", flag: "🇪🇸", iso2: "es" },
  { code: "+51", name: "Perú", flag: "🇵🇪", iso2: "pe" },
  { code: "+54", name: "Argentina", flag: "🇦🇷", iso2: "ar" },
  { code: "+56", name: "Chile", flag: "🇨🇱", iso2: "cl" },
  { code: "+57", name: "Colombia", flag: "🇨🇴", iso2: "co" },
  { code: "+591", name: "Bolivia", flag: "🇧🇴", iso2: "bo" },
  { code: "+593", name: "Ecuador", flag: "🇪🇨", iso2: "ec" },
  { code: "+52", name: "México", flag: "🇲🇽", iso2: "mx" },
  { code: "+1", name: "Estados Unidos", flag: "🇺🇸", iso2: "us" },
  { code: "+55", name: "Brasil", flag: "🇧🇷", iso2: "br" },
];


export default countryOptions;